import React from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import TabPanel from '../TabPanel/TabPanel';
import DetailsRating from '../DetailsRating/DetailsRating';
import GiftDetailsDescription from '../DetailsDescription/GiftDetailsDescription';


const GiftShopReviewsAndRating = () => {
    const [value, setValue] = React.useState(0); // Use numeric index for simplicity

    const handleChange = (event, newValue) => {
      setValue(newValue);
    };
      return (
          <Box sx={{ width: '100%',fontFamily: theme=> theme.typography.smallText, }}>
            <Tabs
              value={value}
              onChange={handleChange}
              textColor="secondary"
              indicatorColor="secondary"
              aria-label="secondary tabs example"
            >
              <Tab value={0} label="Gift Description" sx={{borderRadius:'4px', textTransform:'unset'}}/>
              <Tab value={1} label="Rating & Reviews" sx={{borderRadius:'4px', textTransform:'unset'}}/>
            </Tabs>
      
            {/* Tab Panels for each tab */}
            <TabPanel value={value} index={0}>
              <GiftDetailsDescription/>
            </TabPanel>
            <TabPanel value={value} index={1}>
              <DetailsRating/>
            </TabPanel>
          </Box>
        );
}

export default GiftShopReviewsAndRating